// @flow

// Links to best of category posts

const SurveyAppsLink = {
  text: 'Survey Software',
  href: '/learn/forms-surveys/best-survey-apps/',
};

const CustomerSupportAppsLink = {
  text: 'Customer Support Software',
  href: '/learn/customer-support/best-customer-support-apps/',
};

const FormsAppsLink = {
  text: 'Forms Software',
  href: '/learn/forms-surveys/best-online-form-builder-software/',
};

const SignatureAppsLink = {
  text: 'Signatures Software',
  href: '/blog/best-digital-signature-apps/',
};

const TeamChatAppsLink = {
  text: 'Team Chat Apps',
  href: '/blog/best-team-chat-app/',
};

const NewsletterAppsLink = {
  text: 'Email Newsletter Software',
  href: '/learn/email-marketing/best-email-newsletter-software/',
};

// Links to app pages on Zapier

const MailChimpLink = {
  text: 'MailChimp',
  href: '/apps/mailchimp/integrations',
};

const ZendeskLink = {
  text: 'Zendesk',
  href: '/apps/zendesk/integrations',
};

const GoogleAnalytics = {
  text: 'Google Analytics',
  href: '/apps/google-analytics/integrations',
};

const MSOutlookLink = {
  text: 'Microsoft Outlook',
  href: '/apps/microsoft-outlook/integrations',
};

const ShopifyLink = {
  text: 'Shopify',
  href: '/apps/shopify/integrations',
};

const PipedriveLink = {
  text: 'Pipedrive',
  href: '/apps/pipedrive/integrations',
};

const GoogleDriveLink = {
  text: 'Google Drive',
  href: '/apps/google-drive/integrations',
};

const MicrosoftTeamsLink = {
  text: 'Microsoft Teams',
  href: '/apps/microsoft-teams/integrations',
};

export const HubSpotLink = {
  text: 'HubSpot',
  href: '/apps/hubspot-crm/integrations',
};

const GmailLink = {
  text: 'Gmail',
  href: '/apps/gmail/integrations',
};

const IntegrationsLink = {
  text: 'Box',
  href: '/apps/box/integrations',
};

const MarketoLink = {
  text: 'Marketo',
  href: '/apps/marketo/integrations',
};

// Links to blog posts

const GetThingsDoneLink = {
  image:
    'https://images.zapier.com/storage/blog/90ddce16ae49bc6c4219614bb428a127.250x250.png',
  text: 'Easy GTD: How to Get Things Done or Get Back on the GTD Wagon',
  href: '/blog/gtd-getting-things-done/',
};

const OptimizeGmailLink = {
  image:
    'https://images.zapier.com/storage/blog/c7cdbf72a1627e9e6bd11643f903313b.250x250.jpg',
  text:
    'A Guide to Optimizing Gmail: 30 of the Best Email Tips, Tricks, and Hacks',
  href: '/blog/organize-search-automate-gmail-inbox/',
};

const ToDoListsLink = {
  image:
    'https://images.zapier.com/storage/blog/98dcd3cde193bb2e775afca98786b194.250x250.jpg',
  text: 'Stress-Free Productivity: How to Make To-do Lists Work For You',
  href: '/blog/stress-free-todo-list/',
};

// Blog link with submenu

const blogLink = {
  href: '/blog',
  icon: 'navBlog',
  text: 'Tips & Advice',
  submenu: [
    {
      title: 'Best Of',
      links: [
        SurveyAppsLink,
        CustomerSupportAppsLink,
        FormsAppsLink,
        SignatureAppsLink,
        TeamChatAppsLink,
        NewsletterAppsLink,
      ],
    },
    {
      title: 'Explore',
      links: [
        MailChimpLink,
        ZendeskLink,
        GoogleAnalytics,
        MSOutlookLink,
        ShopifyLink,
        PipedriveLink,
        GoogleDriveLink,
        MicrosoftTeamsLink,
        HubSpotLink,
        GmailLink,
        IntegrationsLink,
        MarketoLink,
      ],
    },
    {
      title: 'Tips & Advice',
      links: [GetThingsDoneLink, OptimizeGmailLink, ToDoListsLink],
    },
  ],
};

export default blogLink;
